import * as React from 'react'

export const SVG_Info = (props: { color: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g fill={props.color} fillRule="evenodd">
            <path d="M10 8c.552 0 1 .318 1 .71v4.58c0 .392-.448.71-1 .71s-1-.318-1-.71V8.71c0-.392.448-.71 1-.71" />
            <path d="M10 18.438A8.433 8.433 0 0 0 18.438 10 8.433 8.433 0 0 0 10 1.562 8.433 8.433 0 0 0 1.562 10 8.433 8.433 0 0 0 10 18.438zM10 0c5.527 0 10 4.473 10 10s-4.473 10-10 10S0 15.527 0 10 4.473 0 10 0z" />
            <path d="M10 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2" />
        </g>
    </svg>
)
